import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TabinfoService } from '../../components/tabinfo/tabinfo.service';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { Router } from '@angular/router';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    PdfTableColumn,
    StatusTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { BioSicherheitPlanSchwein } from '../bio-sicherheits-plan-schwein/BioSicherheitPlanSchwein';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { HttpParams } from '@angular/common/http';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { Benutzerprofil } from '../../../../projects/kiene-core/src/lib/components/stammdaten/mein-profil/mein-profil';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Signature } from '../../../../projects/kiene-core/src/lib/components/unterschriften/signature';
import { UnterschriftenService } from '../../../../projects/kiene-core/src/lib/components/unterschriften/unterschriften.service';

@Component({
    selector: 'kiene-bio-sicherheitsplan-uebersicht',
    templateUrl: './bio-sicherheitsplan-uebersicht.component.html',
    styleUrls: ['./bio-sicherheitsplan-uebersicht.component.scss'],
})
export class BioSicherheitsplanUebersichtComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();
    benutzerProfil: Benutzerprofil;

    constructor(
        public dialog: MatDialog,
        private readonly messageService: MessageService,
        private readonly pdf: PdfViewerDesktopService,
        private readonly api: KieneTableService,
        private readonly api2: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly tabinfoService: TabinfoService,
        private readonly router: Router,
        private readonly localStorageService: LocalStorageService,
        private readonly currentClientService: ChangeCurrentClientService,
        private readonly unterschriftService: UnterschriftenService,
    ) {}

    ngOnInit() {
        this.ladeBenutzerprofil(undefined);

        this.api.watchDataLoadedCompleted().subscribe({
            next: () => {
                this.tabinfoService.setReload('biosicherheitsplan_schwein/tabinfo.php');
            },
        });

        this.tableDescriptor.headline = 'Bio-Sicherheitspläne Schwein';
        this.tableDescriptor.uniqueIdentifier = 'Bio-Sicherheitsplane Schwein';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'biosicherheitsplan_schwein/';
        this.tableDescriptor.route = '/belege/biosicherheitsplan_schwein/';
        this.tableDescriptor.nameOfIdField = 'bs_id';
        this.tableDescriptor.searchPlaceholder = 'Bio-Sicherheitspläne Schwein durchsuchen';
        this.tableDescriptor.initialSortColumn = 'bs_id';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.sendCurrentClient = true;

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);
        this.tableDescriptor.addVoid = this.addPlan.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('bs_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('vvvo', 'Kunde VVVO'));
        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('zusatz', 'Zusatz'));
        const valueColorMap = new Map<number, string>();
        valueColorMap.set(231, '#ff9100');
        valueColorMap.set(232, '#198f13');
        valueColorMap.set(250, '#03a5fc');
        valueColorMap.set(251, '#9c27b0');

        this.tableDescriptor.columns.push(new DateTableColumn('v1_1_datum', 'Datum', 'dd.MM.yy'));
        this.tableDescriptor.columns.push(new TableColumn('tierarzt', 'Tierarzt'));
        this.tableDescriptor.columns.push(new StatusTableColumn('status', 'Status', valueColorMap));
        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.showPdf.bind(this)));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('unterschrift_kunde', 'Unterschrieben'));
        this.tableDescriptor.columns.push(new DateTableColumn('editiert', 'Editiert am'));
        this.tableDescriptor.columns.push(new TableColumn('editiert_von', 'Editiert von'));

        this.tableDescriptor.options.push(
            new TableOption(this.reopen.bind(this), 'wieder öffnen', 'lock_reset', 11003, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.duplicatePlan.bind(this), 'duplizieren', 'file_copy', 11001),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.deletePlan.bind(this), 'löschen', 'delete', 11003, {
                conditions: [new Condition('status_id', Operator.GLEICH, 231)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.beantragt.bind(this), 'TSK beantragt', 'check', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.nichtBeantragt.bind(this), 'TSK nicht beantragt', 'undo', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.bezahlt.bind(this), 'TSK bezahlt', 'check_circle', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(
                this.createEvaluationsbogen.bind(this),
                'Evaluationsbogen erstellen',
                'assignment',
                11001,
                {
                    conditions: [new Condition('status_id', Operator.GLEICH, 251)],
                },
            ),
        );
        if (
            this.localStorageService.isCurrentUserKundeAdmin() ||
            this.localStorageService.isCurrentUserViehhaendlerAdmin()
        ) {
            this.tableDescriptor.options.push(
                new TableOption(this.sign.bind(this), 'unterschreiben', 'draw', 11007, {
                    conditions: [
                        new Condition('unterschrift_kunde', Operator.KLEINER, 1),
                        new Condition('tierarzt_id', Operator.EXISTIERT, null),
                    ],
                }),
            );
        }

        this.tableDescriptor.permissionView = 11000;
        this.tableDescriptor.permissionCreate = 11001;

        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: erstellt', 231, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: abgeschlossen', 232, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK beantragt', 250, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK bezahlt', 251, FilterItemType.CHECKBOX, 'status_id', true),
        );
    }

    ladeBenutzerprofil(bsps: BioSicherheitPlanSchwein) {
        this.api2.get(this.apiBaseUrl + 'benutzerprofil/read_one_kundenportal.php').subscribe({
            next: (response: Benutzerprofil) => {
                this.benutzerProfil = response;
                if (bsps && this.benutzerProfil?.unterschrift_png) {
                    this.dokumentUnterschreiben(bsps);
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    public dokumentUnterschreiben(bsps: BioSicherheitPlanSchwein) {
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update_unterschrift.php', bsps).subscribe({
            next: () => {
                this.messageService.infoMessage('Ihre Unterschrift wurde erfolgreich im Dokument eingefügt!');
                this.api.reload();
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    private sign(bsps: BioSicherheitPlanSchwein) {
        if (this.benutzerProfil?.unterschrift_png) {
            this.dokumentUnterschreiben(bsps);
        } else {
            const signature = new Signature();
            signature.benutzer = 1;
            this.unterschriftService.unterschreiben(signature).subscribe({
                next: () => {
                    this.ladeBenutzerprofil(bsps);
                },
            });
        }
    }

    gotoDetails(bsp: BioSicherheitPlanSchwein) {
        if (!this.canOpenPlan()) {
            this.messageService.hintMessage('Keine Berechtigung zum Öffnen des Biosicherheitsplans.');
            return;
        }
        this.router.navigate(['belege/biosicherheitsplanschwein/' + bsp.bs_id]).then();
    }

    private canOpenPlan(): boolean {
        return (
            this.localStorageService.hasPermission(11000) || this.localStorageService.hasPermission(11002)
        );
    }

    addPlan() {
        const client = this.localStorageService.getCurrentClient();
        if (!client) {
            this.currentClientService.openChangeDialog({ nurSchweinebetriebe: true }).subscribe({
                next: (client: Client) => {
                    if (client) {
                        this.addPlan();
                    }
                },
            });
        } else {
            if (!LocalStorageService.isClientSchwein(client)) {
                this.messageService.hintMessage(
                    'Ausgewählter Betrieb ist kein Schweine-Betrieb. Bitte wählen Sie einen gültigen Betrieb aus.',
                );
            } else {
                this.router.navigate(['belege/biosicherheitsplanschwein/0']).then();
            }
        }
    }

    beantragt(bsb: BioSicherheitPlanSchwein) {
        this.statusAendern(bsb, 250);
    }

    nichtBeantragt(bsb: BioSicherheitPlanSchwein) {
        this.statusAendern(bsb, 232);
    }

    bezahlt(bsb: BioSicherheitPlanSchwein) {
        this.statusAendern(bsb, 251);
    }

    private statusAendern(bsb: BioSicherheitPlanSchwein, status_id: number) {
        bsb.status_id = status_id;
        this.api.updateEntity(this.apiBaseUrl + 'biosicherheitsplan_schwein/beantragt.php', bsb).subscribe({
            next: () => {
                this.api.reload();
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.api.reload();
            },
        });
    }

    deletePlan(bsb: BioSicherheitPlanSchwein) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bio-Sicherheitsplan-Schwein löschen';
        input.text = 'Möchten Sie den Plan wirklich löschen?';
        input.okButton = 'Löschen';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        this.api
                            .deleteEntity(this.apiBaseUrl + 'biosicherheitsplan_schwein/delete.php', bsb)
                            .subscribe({
                                next: () => {
                                    this.api.reload();
                                },
                                error: error => {
                                    this.messageService.errorMessage(
                                        'Fehler beim Löschen des Bio-Sicherheitsplans',
                                        error,
                                    );
                                },
                            });
                    }
                },
            });
    }

    reopen(bsb: BioSicherheitPlanSchwein) {
        const input = new ConfirmDialogInput();
        input.headline = 'Status ändern';
        input.text = 'Soll der Biosicherheitsplan wieder zur Bearbeitung freigegeben werden?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        bsb.status_id = 231;
                        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update.php', bsb).subscribe({
                            next: () => {
                                this.router.navigate(['belege/biosicherheitsplanschwein/' + bsb.bs_id]).then();
                            },
                            error: error => {
                                this.messageService.errorMessage('Fehler beim Ändern des Status', error);
                            },
                        });
                    }
                },
            });
    }

    showPdf(selectedBsp: BioSicherheitPlanSchwein) {
        const titel = 'Bio-Sicherheitsplan ' + selectedBsp?.bs_id;

        const input = new PdfViewerDialogInput(
            'biosicherheitsplan_schwein/read_or_mail_pdf.php',
            new HttpParams().set('bs_id', selectedBsp?.bs_id?.toString()),
            titel,
            { email: { sende_mail: true, kunde_id: selectedBsp?.kunde_id } },
        );
        this.pdf.openPdfViewer(input);
    }

    createEvaluationsbogen(bsp: BioSicherheitPlanSchwein) {
        const input = new ConfirmDialogInput();
        input.headline = 'Evaluationsbogen erstellen';
        input.text =
            'Aus diesem TSK-bezahlten Biosicherheitsplan einen Evaluationsbogen anlegen? Stammdaten und offene Handlungsempfehlungen werden übernommen.';
        input.okButton = 'Erstellen';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (!response?.ok || !response?.confirmed) {
                        return;
                    }
                    this.api2
                        .post(this.apiBaseUrl + 'evaluationsbogen_schwein/create_from_bsp.php', {
                            bs_id: bsp.bs_id,
                        })
                        .subscribe({
                            next: (res: any) => {
                                const ebId = res?.eb_id;
                                if (!ebId) {
                                    this.messageService.hintMessage(
                                        'Evaluationsbogen wurde angelegt, aber keine ID zurückgegeben.',
                                    );
                                    return;
                                }
                                this.messageService.infoMessage('Evaluationsbogen wurde erstellt.');
                                this.router.navigate(['belege/evaluationsbogen-schwein/' + ebId]).then();
                            },
                            error: err =>
                                this.messageService.errorMessage(
                                    'Evaluationsbogen konnte nicht erstellt werden.',
                                    err,
                                ),
                        });
                },
            });
    }

    private duplicatePlan(value: any) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bio-Sicherheitsplan-Schwein duplizieren';
        input.text = 'Möchten Sie den Plan wirklich duplizieren?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        this.api
                            .duplicateEntity(this.apiBaseUrl + 'biosicherheitsplan_schwein/duplicate.php', value)
                            .subscribe({
                                next: () => {
                                    this.api.reload();
                                },
                                error: error => {
                                    this.messageService.errorMessage(
                                        'Fehler beim Duplizieren des Bio-Sicherheitsplans',
                                        error,
                                    );
                                },
                            });
                    }
                },
            });
    }
}
